import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layout/DefaultLayout.vue'
import HomeView from '@/views/HomeView.vue'
import { useUserStore } from '@/stores/user.ts'

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      children: [
        {
          path: '/',
          name: 'home',
          component: HomeView,
          meta: { auth: true },
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('../views/auth/login/LoginView.vue'),
          meta: { auth: false },
        },
        {
          path: '/material',
          name: 'Material',
          component: () => import('@/views/material/MaterialView.vue'),
        },
        {
          path: '/material/mein',
          name: 'MeinMaterial',
          component: () => import('@/views/material/MeinMaterialView.vue'),
        },
        {
          path: '/material/digola',
          name: 'DigolaMaterial',
          component: () => import('@/views/material/DigolaMaterialView.vue'),
        },
        {
          path: '/material/community',
          name: 'CommunityMaterial',
          component: () => import('@/views/material/CommunityMaterialView.vue'),
        },
        {
          path: '/material/search',
          name: 'MaterialSearch',
          component: () => import('@/views/material/MaterialSearchView.vue'),
        },
        {
          path: '/patients',
          name: 'patients',
          component: () => import('../views/patients/PatientsView.vue'),
          meta: { auth: true },
        },
      ],
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  if (to.meta.auth && !userStore.isLoggedIn) {
    await userStore.initialize()
    if (!userStore.isLoggedIn) {
      next({ name: 'login' })
    }
  }
  next()
})

export default router
